import baseConstant from './development'
let constant = baseConstant

// 僅調整與 dev 有差別的部分就好
// constant = { ...constant, apiUrl: 'http://11.22.33.44/api/' }
// console.log(process.env.MODE)
switch (process.env.MODE) {
    case 'STA':
        constant = { 
            ...constant, 
            webApiUrl: 'http://61.220.158.181:5048',
            appApiUrl: 'http://61.220.158.181:5048',
            webUrl: 'http://61.220.158.181:5048/',
        }
        break
    case 'PROD':
        constant = { 
            ...constant, 
            webApiUrl: 'https://app.fetuzbook.com',
            appApiUrl: 'https://app.fetuzbook.com',
            webUrl: 'https://www.fetuzbook.com/',
            imageUrlNoCdn: 'https://app.fetuzbook.com',
            imageUrl: 'https://cdn.fetuzbook.com',
            fetuzbookLandlordSchema: 'flypiglandlord',
            fetuzbookTenantSchema: 'flypigtenant',
            beforeRefreshTokenExpiredDate: 86400000,
            gtmId: '523D6F4',
            firebaseConfig: {
                apiKey: "AIzaSyBjL2kUSzLWoQJRsHsI__UdRe_cru2_8v0",
                authDomain: "flypig-web-8b959.firebaseapp.com",
                databaseURL: "https://flypig-web-8b959.firebaseio.com",
                projectId: "flypig-web-8b959",
                storageBucket: "flypig-web-8b959.appspot.com",
                messagingSenderId: "414897195539",
                appId: "1:414897195539:web:0f22bee9f5b97f52630de6",
                measurementId: "G-1WST1VWVP2"
            },
            firebaseBizConfig: {
                apiKey: "AIzaSyDk0TOeEtfqefP-C0wzlvPa25xdChOil2I",
                authDomain: "flypig-web-biz.firebaseapp.com",
                databaseURL: "https://flypig-web-biz.firebaseio.com",
                projectId: "flypig-web-biz",
                storageBucket: "flypig-web-biz.appspot.com",
                messagingSenderId: "212786517838",
                appId: "1:212786517838:web:852676e53cc97fa81f301f",
                measurementId: "G-DT6PGCRMMF"
            },
            firebaseTenantConfig: {
                apiKey: "AIzaSyCVDEWFHW8-AsC284qzNHjUzHA0BNu_xPk",
                authDomain: "flyping-dc161.firebaseapp.com",
                databaseURL: "https://flyping-dc161.firebaseio.com",
                projectId: "flyping-dc161",
                storageBucket: "flyping-dc161.appspot.com",
                messagingSenderId: "683590047322",
                appId: "1:683590047322:web:3c347780250808c6252a63",
                measurementId: "G-M51C27T2SF"
            }
        }
        break
        case 'EXP':
            constant = { 
                ...constant, 
                webApiUrl: 'http://61.220.158.181:5068',
                appApiUrl: 'http://61.220.158.181:5068',
                webUrl: 'http://61.220.158.181:5068/',
            }
        break
}

export default constant


// WEBPACK FOOTER //
// ./src/constant/production.js